import type { Cache } from "@apollo/client";
import { getApolloClientInternal } from "./apolloClient";

export function evict(options: Cache.EvictOptions): boolean {
    return getApolloClientInternal().cache.evict(options);
}
